import axios from "axios";

/**
 * @returns {Promise<axios.AxiosResponse<FedRampProduct[]>>}
 */
export function getProducts() {
  return axios.get("/sewppublic/fedramp/products");
}

/**
 * @param {number} agencyListSeq
 * @returns {Promise<axios.AxiosResponse<FedRampAgencySubAgencyModel[]>>}
 */
export function getAgencySubagencyData(agencyListSeq) {
  return axios.get(`/sewppublic/fedramp/agency-subagency-view/${agencyListSeq}`);
}

/**
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampProductViewModel>>}
 */
export function getProviderDataByProduct(productSeq) {
  return axios.get(`/sewppublic/fedramp/product-view/${productSeq}`);
}

/**
 * @param {number} providerSeq
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampProviderViewModel>>}
 */
export function getProviderDataByProviderAndProduct(providerSeq, productSeq) {
  return axios.get(`/sewppublic/fedramp/provider-view/${providerSeq}/${productSeq}`);
}

/**
 * @param {number} providerSeq
 * @param {number} productSeq
 * @returns {Promise<axios.AxiosResponse<FedRampContractHolder[]>>}
 */
export function getContractHolderData(productSeq, providerSeq) {
  return axios.get(`/sewppublic/fedramp/contract-holder-view/${productSeq}/${providerSeq}`);
}